export type TKpiSliceState = {
    summaryPhasePercentages: TSummaryPhasePercentages | null;
    summaryPhaseCountsOfGeneralSeaAreas: TSummaryPhaseCountsOfGeneralSeaAreas | null;
    summarySignalCountsOnSpeedRanges: TSummarySignalCountsOnSpeedRanges | null;
    summaryKeyMetrics: TSummaryKeyMetrics | null;

    vesselListPhasePercentages: TPhasePercentages[] | null;
    vesselListPhaseCountsOfGeneralSeaAreas: TPhaseCountsOfGeneralSeaAreas[] | null;
    vesselListSignalCountsOnSpeedRanges: TSignalCountsOnSpeedRanges[] | null;
    vesselListKeyMetrics: TKeyMetrics[] | null;
    vesselListSpeedDraughtValues: TVesselSpeedDraughtValues[] | null;

    vesselListPolygonCalls: TPolygonCalls[] | null;
    vesselListVoyages: TVoyages[] | null;
    vesselListStoppageEvents: TStoppageEvents[] | null;

    vesselCohortVoyages: TVoyages | null;
    vesselCohortSignalCountsOnSpeedRanges: TSignalCountsOnSpeedRanges | null;
    vesselCohortPhasePercentagesOfPolygonCalls: TPhasePercentages | null;

    vesselVoyagesHourlyTracks: TVesselVoyagesHourlyTracks | null;

    activityCoverage: TActivityCoverageState | null;
    sectorActivityCoverage: TSectorActivityCoverageState | null;
};

export interface IKpiVessel {
    imoNumber: number;
    name: string;
    sectorId: number
    sectorName: string
}

export type TPhasePercentages = {
    imoNumber: number | null;
    dataList: TPhasePercentagesItem[] | null;
    loading: boolean;
    loadingError: Error | null;
    isFetched: boolean
};

export type TPhasePercentagesItem = {
    operationalPhase: string
    countOfPhase: number
    percentOfPhase: number
};

export type TPhaseCountsOfGeneralSeaAreas = {
    imoNumber: number | null;
    dataList: TPhaseCountsOfGeneralSeaAreasItem[] | null;
    loading: boolean;
    loadingError: Error | null;
};

export type TPhaseCountsOfGeneralSeaAreasItem = {
    generalSeaArea: string
    countOfPhaseAtSea: number
    countOfPhaseAtBerth: number
    countOfPhaseAnchored: number
    countOfPhaseManoeuvring: number
};

export type TSignalCountsOnSpeedRanges = {
    imoNumber: number | null;
    dataList: TSignalCountsOnSpeedRangesItem[] | null;
    loading: boolean;
    loadingError: Error | null;
};

export type TSignalCountsOnSpeedRangesItem = {
    rangeLevel: number
    countOfSpeedRange: number
    countOfBallast: number
    countOfLaden: number
};

export type TStoppageEvents = {
    imoNumber: number | null;
    dataList: TStoppageEventsItem[] | null;
    loading: boolean;
    loadingError: Error | null;
};

export type TStoppageEventsItem = {
    stoppageId: number
    generalSeaArea: string
    latitude: number
    longitude: number
    portName: string
    fromDate: string
    toDate: string
    timeDays: number
    distanceBetweenStop: number
    vesselActivity: string
    isInSanctionArea: boolean
    sanctionArea: string
}

export type TVoyages = {
    imoNumber: number | null;
    dataList: TVoyagesItem[] | null;
    loading: boolean;
    loadingError: Error | null;
    isFetched: boolean
};

export type TVoyagesItem = {
    voyageId: number
    originBerth: string
    originPort: string
    originCountry: string
    originRegion: string
    originPortActivity: string
    originStartTime: string
    originEndTime: string
    totalInOriginPort: number
    fuelConsumedInOriginPort: number
    emissionConsumedInOriginPort: number
    voyageDistance: number
    voyageTime: number
    voyageStatus: string
    fuelConsumedOnVoyage: number
    emissionConsumedOnVoyage: number
    destinationBerth: string
    destinationPort: string
    destinationCountry: string
    destinationRegion: string
    destinationPortActivity: string
    destinationStartTime: string
    destinationEndTime: string
    totalInDestinationPort: number
    fuelConsumedInDestinationPort: number
    emissionConsumedInDestinationPort: number
    totalFuelConsumed: number
    totalEmissionConsumed: number
}

export type TPolygonCalls = {
    imoNumber: number | null;
    dataList: TPolygonCallsItem[] | null;
    loading: boolean;
    loadingError: Error | null;
};

export type TPolygonCallsItem = {
    id: number,
    startTime: string
    endTime: string
    detailedBerthPolygonId: number
    portName: string
    portActivity: string
    totalTimeInPort: number
    timeAtAnchor: number
    timeMoored: number
    timeManeouvring: number
    timeUnclassified: number
    draughtIn: number
    draughtOut: number
    deadweightLoadedOnArrival: number
    deadweightLoadedOnDeparture: number
}

export type TSummarySignalCountsOnSpeedRanges =
    {
        sectorListSignalCountsOnSpeedRanges: TSectorSignalCountsOnSpeedRanges[] | null;
        loading: boolean;
        loadingError: Error | null;
    };

export type TSectorSignalCountsOnSpeedRanges = {
    sectorId: number | null;
    dataList: TSignalCountsOnSpeedRangesItem[] | null;
};

export type TSummaryPhasePercentages =
    {
        sectorListPhasePercentages: TSectorPhasePercentages[] | null;
        loading: boolean;
        loadingError: Error | null;
    };

export type TSectorPhasePercentages = {
    sectorId: number | null;
    dataList: TPhasePercentagesItem[] | null;
};

export type TSummaryPhaseCountsOfGeneralSeaAreas =
    {
        sectorListPhaseCountsOfGeneralSeaAreas: TSectorPhaseCountsOfGeneralSeaAreas[] | null;
        loading: boolean;
        loadingError: Error | null;
    };

export type TSectorPhaseCountsOfGeneralSeaAreas = {
    sectorId: number | null;
    dataList: TPhaseCountsOfGeneralSeaAreasItem[] | null;
};

export type TSummaryKeyMetrics =
    {
        sectorListKeyMetrics: TSectorKeyMetrics[] | null;
        loading: boolean;
        loadingError: Error | null;
    };


export type TSectorKeyMetrics = {
    sectorId: number | null;
    startDate: Date
    endDate: Date
    data: TKeyMetricsItem | null;
};

export type TKeyMetrics = {
    imoNumber: number | null;
    data: TKeyMetricsItem | null;
    loading: boolean;
    loadingError: Error | null;
};

export type TKeyMetricsItem = {
    startDate: Date
    endDate: Date
    voyagesCount: number
    totalDistance: number
    fuelConsumed: number
    co2Emissions: number
    co2EmissionsWtW: number
    ladenCount: number
    averageLadenSpeed: number
    averageLadenDraftPercentage: number
    ballastCount: number
    averageBallastSpeed: number
    averageBallastDraftPercentage: number
    averageVoyageDistance: number
    averageVoyageDays: number
    averagePortCallsDays: number

    mainEngineFuelConsumed: number
    mainEnginePilotFuelConsumed: number
    auxiliaryEngineFuelConsumed: number
    boilerFuelConsumed: number
    mainEngineEmissions: number
    mainEnginePilotEmissions: number
    auxiliaryEngineEmissions: number
    boilerEmissions: number
    lsfoMainEngineFuelConsumed: number
    mdoMainEngineFuelConsumed: number
    totalTimeInShipyard: number
    averageDaysInOriginPort: number
    averageDaysInDestinationPort: number
    averageFuelConsumed: number
    averageCo2Emissions: number

}

export type TVesselSpeedDraughtValues = {
    imoNumber: number | null;
    dataList: TSpeedDraughtValueItem | null;
    loading: boolean;
    loadingError: Error | null;
};

export type TSpeedDraughtValueItem = {
    signalDateTime: string,
    loadedCondition: string
    speed: number
    percentDraught: number
}

export type TCountsOfGeneralSeaAreas = {
    generalSeaArea: string;
    totalPhases: number;
    percentageOfTotal: number;
};

export type TVesselVoyagesHourlyTracks = {
    imoNumber: number | null;
    dataList: TVesselVoyagesHourlyTracksItem[] | null;
    loading: boolean;
    loadingError: Error | null;
};

export type TVesselVoyagesHourlyTracksItem = {
    signalDateTime: string | null;
    hoursSincePreviousSignal: number | null;
    longitude: number | null;
    latitude: number | null;
    heading: number | null;
    percentDesignDraught: number | null;
    speed: number | null;
    operationalPhase: string | null;
    generalSeaArea: string | null;
    loadedCondition: string | null;
};

export type TActivityCoverageState = {
    activityCoverageData: TActivityCoverage | null;
    loadingError: Error | null;
    loading: boolean;
};

export type TActivityCoverage = {
    calculatedImoCount: number | null;
    imoCount: number | null;
    coveragePercentage: number | null;
};

// Sector (Summary output) scoped activity coverage - holds the coverage result for the
// currently active sector tab only; a new sector selection overwrites this with a new request/result.
export type TSectorActivityCoverageState = {
    activityCoverageData: TActivityCoverage | null;
    loadingError: Error | null;
    loading: boolean;
};

// Slice name in the ...Slice.ts file
export const KPI = 'kpi';

// Action name in ...Slice.ts file that will be called from component
export const actionTypes = {
    GET_SUMMARY_KEY_METRICS: `${KPI}/getSummaryKeyMetricsRequestAction`,
    GET_SUMMARY_PHASE_COUNTS_OF_GENERAL_SEA_AREAS: `${KPI}/getSummaryPhaseCountsOfGeneralSeaAreasRequestAction`,
    GET_SUMMARY_PHASE_PERCENTAGES: `${KPI}/getSummaryPhasePercentagesRequestAction`,
    GET_SUMMARY_SIGNAL_COUNTS_ON_SPEED_RANGES: `${KPI}/getSummarySignalCountsOnSpeedRangesRequestAction`,

    GET_PHASE_PERCENTAGES: `${KPI}/getPhasePercentagesRequestAction`,
    GET_PHASE_COUNTS_OF_GENERAL_SEA_AREAS: `${KPI}/getPhaseCountsOfGeneralSeaAreasRequestAction`,
    GET_SIGNAL_COUNTS_ON_SPEED_RANGES: `${KPI}/getSignalCountsOnSpeedRangesRequestAction`,
    GET_VESSEL_KEY_METRICS: `${KPI}/getVesselKeyMetricsRequestAction`,
    GET_VESSEL_SPEED_DRAUGHT_ON_LOADED_CONDITION: `${KPI}/getVesselSpeedAndDraughtOnLoadedConditionsRequestAction`,
    GET_VESSEL_POLYGON_CALLS: `${KPI}/getVesselPolygonCallsRequestAction`,
    GET_VESSEL_VOYAGES: `${KPI}/getVesselVoyagesRequestAction`,
    GET_VESSEL_STOPPAGE_EVENTS: `${KPI}/getVesselStoppageEventsRequestAction`,
    GET_VESSEL_COHORT_VOYAGES: `${KPI}/getVesselCohortVoyagesRequestAction`,
    GET_VESSEL_COHORT_SIGNAL_COUNTS_ON_SPEED_RANGES: `${KPI}/getVesselCohortSignalCountsOnSpeedRangesRequestAction`,
    GET_VESSEL_COHORT_PHASE_PERCENTAGES_OF_POLYGON_CALLS: `${KPI}/getVesselCohortPhasePercentagesOfPolygonCallsRequestAction`,
    GET_VESSEL_VOYAGES_HOURLY_TRACKS: `${KPI}/getVesselVoyagesHourlyTracksRequestAction`,
    GET_ACTIVITY_COVERAGE: `${KPI}/getActivityCoverageRequestAction`,
    GET_SECTOR_ACTIVITY_COVERAGE: `${KPI}/getSectorActivityCoverageRequestAction`,
};